import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/**
 * Initializes Swiper galleries in post content.
 */
export const initGalleries = (): void => {
  const galleries = document.querySelectorAll<HTMLElement>(
    ".post-content-gallery__slider"
  );

  if (galleries.length === 0) {
    return;
  }

  galleries.forEach((gallery) => {
    // Prevent double initialization
    if (gallery.dataset.initialized === "true") return;
    gallery.dataset.initialized = "true";

    new Swiper(gallery, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoHeight: true, // Adapt to image height
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });

  console.log(`[Gallery] Initialized ${galleries.length} galleries.`);
};
